<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                <li class="breadcrumb-item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item"><router-link to="/logs">Logs</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">View Log</li>
            </ol>
            <h4 class="main-title mb-0">Logs</h4>
            </div>
            <div>
                <router-link to="/logs" type="submit" class="btn btn-primary" ><i class="ri-list-check fs-18 lh-1"></i> Logs</router-link>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">View Log</h6>
                    </div>
                    <div class="card-body">
                        <div class="row g-4 g-md-5 g-xl-4 g-xxl-5">
                            <div class="col-md-3">
                                <div class="profile-item">
                                    <i class="ri-file-line"></i>
                                    <div class="profile-item-body">
                                        <p>File</p>
                                        <span>{{ log.file_path }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="profile-item">
                                    <i class="ri-calendar-schedule-line"></i>
                                    <div class="profile-item-body">
                                        <p>Date & Time</p>
                                        <span>{{ formatDate(log.date_time) }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="profile-item">
                                    <i class="ri-chat-2-line"></i>
                                    <div class="profile-item-body">
                                        <p>Message</p>
                                        <span>{{ log.message }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="profile-item">
                                    <i class="ri-chat-2-line"></i>
                                    <div class="profile-item-body">
                                        <p>Status</p>
                                        <span :class="log.status_class" style="color:white">{{ log.status }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="table-responsive table-responsive-sm">
                                    <table class="table table-bordered table-striped table-sm">
                                     <thead>
                                    <tr style="background-color: #9b9b9b; color: white;">
                                        <th class="text-center">#</th>
                                        <th>Row</th>
                                        <th>Attribute</th>
                                        <th>Errors</th>
                                        <th>Values</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="log.logerrors?.length==0">
                                        <td colspan="4" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="logerror, key in log.logerrors" :key="key">
                                        <td class="text-center">{{ key+1}}</td>
                                        <td>{{ logerror.row }}</td>
                                        <td>{{ logerror.attribute}}</td>
                                        <td><span v-for="error, key1 in logerror.errors" :key="key1">{{error}}</span></td>
                                        <td>{{ logerror.values }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
               <!----- <div class="card">
                  <div class="card-body">
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-bordered table-striped table-sm">
                                <thead>
                                    <tr style="background-color: #9b9b9b; color: white;">
                                        <th class="text-center">#</th>
                                        <th>Row</th>
                                        <th>Attribute</th>
                                        <th>Errors</th>
                                        <th>Values</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="log.logerrors?.length==0">
                                        <td colspan="4" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="logerror, key in log.logerrors" :key="key">
                                        <td class="text-center">{{ key+1}}</td>
                                        <td>{{ logerror.row }}</td>
                                        <td>{{ logerror.attribute}}</td>
                                        <td><span v-for="error, key1 in logerror.errors" :key="key1">{{error}}</span></td>
                                        <td>{{ logerror.values }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>--->
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                log: {
                    log_id: "",
                },
                errors: [],
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.log.log_id = to.params.log_id;
                let uri = { uri: "getLog", data: vm.log };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        vm.log = response.data.data;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            });
        },

        methods: {
            formatDate(dateTime) {
            const date = new Date(dateTime);
            return date.toLocaleString('en-US', { month: 'long', day: 'numeric', year: 'numeric',hour: '2-digit', minute: '2-digit'}); 
        },
    },
};   
</script>
